@if (imageUrl()) {
  <img
    [src]="imageUrl()"
    [alt]="altText()"
    class="user-avatar user-avatar--image"
    [style.width]="size()"
    [style.height]="size()" />
} @else {
  <div
    class="user-avatar user-avatar--initials"
    [style.width]="size()"
    [style.height]="size()"
    [style.font-size]="fontSize()"
    [attr.aria-label]="altText()">
    {{ initials() }}
  </div>
}
